import React, {useState, useRef,useEffect, useContext} from 'react';
import {IProps} from './types';
import * as S from './styles';
import { ArrowDownIcon } from '@assets/icons/arrowDownIcon';
import { SortIcon } from '@assets/icons/sortIcon';
import { DesignsContext } from '@utils/DOIgnition/DesignsContext';

const Order:React.FC<IProps> = (props) => {
  const{ sortByMenu, sortByQuery, handleChangeSortBy } = useContext(DesignsContext);
  const [showMenu, setShowMenu]= useState(false);
  const [selected, setSelected]= useState(-1);
  const componentRef = useRef(null);

  const handleClickBtn = ()=>setShowMenu(!showMenu);

  const handleClickOption = (idx:number)=>{
    if(selected!==idx){
      setSelected(idx);
      setShowMenu(false);
      handleChangeSortBy(idx);
    }
  }

  const handleClickOutside = (e: any)=> {
    if(componentRef && componentRef.current){
        const ref: any = componentRef.current
        if(!ref.contains(e.target))setShowMenu(false);
    }
  }

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [])

  useEffect(() => {
    if (sortByQuery==='') setSelected(-1);
  }, [sortByQuery])

  return (
    <S.Root ref={componentRef}>
      <S.Label>Sort by:     </S.Label>
      <S.Btn onClick={handleClickBtn} selected={selected!=-1?true:false}>
        <SortIcon/>
        <ArrowDownIcon/>
      </S.Btn>
      <S.Menu style={{display: showMenu?'block':'none'}}>
          {sortByMenu.map((item: any, idx: number)=>
          <S.Option key={`op${idx}`} selected={idx===selected?true:false} onClick={()=>handleClickOption(idx)}>
            {item.title}
            {item.extra && <S.Extra>{item.extra}</S.Extra>}
          </S.Option>)}
      </S.Menu>
    </S.Root >
  );
}

export default Order;